<template>
  <div>
    <exitIntentSurvey v-if="settings.showExitIntentSurvey" />
  </div>
</template>

<script lang="ts">
import {
  Component, Prop, Vue
} from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import IInitialSettingsViewModel from '@/models/interfaces/IInitialSettingsViewModel';
import ExitIntentSurveyComponent from '../general/ExitIntentSurveyComponent.vue';

const InitialSettingModule = namespace('initialSettingsModule');

@Component({
  components: {
    exitIntentSurvey: ExitIntentSurveyComponent
  }
})
export default class InitialSettingsComponent extends Vue {
  @InitialSettingModule.Action public submitInitialSettings;

  @Prop({ default: null })
  public settings!: IInitialSettingsViewModel;

  public created() {
    this.submitInitialSettings(this.settings);
  }
}
</script>
